export const assertNonEmptyName = (name: string) => {
  if (!name) {
    throw new Error('Name is required');
  }
};
